import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var ContractRewardItem = function (_a) {
    var buff = _a.buff, icon = _a.icon, children = _a.children;
    return (React.createElement("div", { className: "market-menu__rewards-item" },
        React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: icon }),
        React.createElement("div", { className: IdStyles.TextBoldAccent },
            children,
            React.createElement(NumberFormat, { amount: buff || Long.ZERO, format: TypeNumberFormat.AddExceptZero }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/ContractRewardItem.tsx
// module id = 2714
// module chunks = 3